import { render, staticRenderFns } from "./AdminNoticeEdit.vue?vue&type=template&id=12df03c4&scoped=true&lang=pug&"
import script from "./AdminNoticeEdit.vue?vue&type=script&lang=ts&"
export * from "./AdminNoticeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df03c4",
  null
  
)

export default component.exports